<template>
    <div id="circleLoading">
		<div class="circle-loader">
			<div class="circle-line">
				<div class="circle circle-blue"></div>
				<div class="circle circle-blue"></div>
				<div class="circle circle-blue"></div>
			</div>
			<div class="circle-line">
				<div class="circle circle-yellow"></div>
				<div class="circle circle-yellow"></div>
				<div class="circle circle-yellow"></div>
			</div>
			<div class="circle-line">
				<div class="circle circle-red"></div>
				<div class="circle circle-red"></div>
				<div class="circle circle-red"></div>
			</div>
			<div class="circle-line">
				<div class="circle circle-green"></div>
				<div class="circle circle-green"></div>
				<div class="circle circle-green"></div>
			</div>
		</div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #circleLoading{
		width: 150px;
		height: 150px;
		position: relative;
		transform: scale(0.5);
		.circle-loader {
			display: block;
			width: 128px;
			height: 128px;
			margin-left: -32px;
			margin-top: -32px;
			position: absolute;
			left: 50%;
			top: 50%;
			-webkit-transform-origin: 16px 16px;
			transform-origin: 16px 16px;
			-webkit-animation: rotate-animation 5s infinite;
			animation: rotate-animation 5s infinite;
			-webkit-animation-timing-function: linear;
			animation-timing-function: linear;
			.circle-line {
				width: 128px;
				height: 64px;
				position: absolute;
				top: 4px;
				left: 0;
				-webkit-transform-origin: 4px 4px;
				transform-origin: 4px 4px;
				&:nth-child(0) {
					-webkit-transform: rotate(0deg);
					transform: rotate(0deg);
				}
				&:nth-child(1) {
					-webkit-transform: rotate(90deg);
					transform: rotate(90deg);
				}
				&:nth-child(2) {
					-webkit-transform: rotate(180deg);
					transform: rotate(180deg);
				}
				&:nth-child(3) {
					-webkit-transform: rotate(270deg);
					transform: rotate(270deg);
				}
				.circle {
					-webkit-animation: move-animation 2.5s infinite;
					animation: move-animation 2.5s infinite;
					-webkit-animation-timing-function: linear;
					animation-timing-function: linear;
					position: absolute;
					left: 50%;
					top: 50%;
					&:nth-child(1) {
						width: 8px;
						height: 8px;
						top: 50%;
						left: 50%;
						margin-top: -4px;
						margin-left: -4px;
						border-radius: 4px;
						-webkit-animation-delay: -0.3s;
						animation-delay: -0.3s;
					}
					&:nth-child(2) {
						width: 16px;
						height: 16px;
						top: 50%;
						left: 50%;
						margin-top: -8px;
						margin-left: -8px;
						border-radius: 8px;
						-webkit-animation-delay: -0.6s;
						animation-delay: -0.6s;
					}
					&:nth-child(3) {
						width: 24px;
						height: 24px;
						top: 50%;
						left: 50%;
						margin-top: -12px;
						margin-left: -12px;
						border-radius: 12px;
						-webkit-animation-delay: -0.9s;
						animation-delay: -0.9s;
					}
					&.circle-blue {
						background-color: #1f4e5a;
					}
					&.circle-red {
						background-color: #ff5955;
					}
					&.circle-yellow {
						background-color: #ffb265;
					}
					&.circle-green {
						background-color: #00a691;
					}
				}
			}
		}
	}
	@keyframes rotate-animation {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes move-animation {
		0% {
			-webkit-transform: translate(0, 0);
			transform: translate(0, 0);
		}
		25% {
			-webkit-transform: translate(-64px, 0);
			transform: translate(-64px, 0);
		}
		75% {
			-webkit-transform: translate(32px, 0);
			transform: translate(32px, 0);
		}
		100% {
			-webkit-transform: translate(0, 0);
			transform: translate(0, 0);
		}
	}
</style>